import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Strict 2-stage gate: must be signed in AND must have completed the $6.95 paywall.
// - Not signed in → /register
// - Signed in but unpaid → /upgrade
// - Paid → render the protected page
export default function PaidRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0C10]">
        <div className="overline" data-testid="paid-loading">Tuning instruments…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/register" state={{ from: location.pathname }} replace />;
  }

  if (!user.has_complete_access) {
    return <Navigate to="/upgrade" state={{ from: location.pathname }} replace />;
  }

  return children;
}
